import { Opportunity } from '../types/opportunity'

export const mockOpportunity: Opportunity = {
  id: 'OPP-2026-0892',
  stage: 'underwriting',
  // Filled fields
  borrowerName: 'Jane Doe',
  loanAmount: 450000,
  propertyAddress: '1234 Maple Street, San Francisco, CA 94102',
  // Missing fields for underwriting
  creditScore: undefined,
  employmentVerified: false,
  incomeDocuments: false,
  // Future fields
  appraisalOrdered: false,
  titleSearch: false,
  // Cases
  cases: [
    {
      id: 'CASE-001',
      title: 'Missing W-2 for 2024',
      status: 'open',
      severity: 'warning',
    },
    {
      id: 'CASE-002',
      title: 'Identity Verification Complete',
      status: 'closed',
      severity: 'info',
    },
  ],
}
